import global from './global.js';
import { Message } from 'element-ui';

function checkLimits(val){
    if(!hasLimits(val)){
        Message.info("没有此权限:"+val);
        return false;
    }
    return true;
}
function success(val){
    Message.success({
        message: val,
        duration: 1000,
    })
}
function warning(val){
    Message.warning({
        message: val,
        duration: 1000,
    })
}
function info(val){
    Message.info({
        message: val,
        duration: 1000,
    })
}
function error(val){
    Message.error({
        message: val,
        duration: 1000,
    })
}
function hasLimits(val){
    if(global.user.indexOf(val)>=0){
        return true;
    }else{
        return false;
    }
}
function checkWindowsEnv(){
    var ua = window.navigator.userAgent;
    if (ua.includes('HarmonyOS') || ua.includes('ArkWeb')) {
        return false;
    }
    if(ua.indexOf("Windows")>-1){
        return true;
    }
    return false;
}
function checkHarmonyEnv(){
    var ua = window.navigator.userAgent;
    if (ua.includes('HarmonyOS') || ua.includes('ArkWeb')) {
        return true;
    }
    return false;
}
function dayformat(date) {
    var year = date.getFullYear() + "";
    var month = date.getMonth() + 1 + "";
    month = month.length > 1 ? month : "0" + month;
    var day = date.getDate() + "";
    day = day.length > 1 ? day : "0" + day;
    return year + "-" + month + "-" + day;
}
function format(date) {
    var year = date.getFullYear() + "";
    var month = date.getMonth() + 1 + "";
    month = month.length > 1 ? month : "0" + month;
    var day = date.getDate() + "";
    day = day.length > 1 ? day : "0" + day;
    var hours = date.getHours() + "";
    hours = hours.length > 1 ? hours : "0" + hours;
    var minutes = date.getMinutes() + "";
    minutes = minutes.length > 1 ? minutes : "0" + minutes;
    return year + "-" + month + "-" + day + " " + hours + ":" + minutes;
}
function formats(date) {
    var year = date.getFullYear() + "";
    var month = date.getMonth() + 1 + "";
    month = month.length > 1 ? month : "0" + month;
    var day = date.getDate() + "";
    day = day.length > 1 ? day : "0" + day;
    var hours = date.getHours() + "";
    hours = hours.length > 1 ? hours : "0" + hours;
    var minutes = date.getMinutes() + "";
    minutes = minutes.length > 1 ? minutes : "0" + minutes;
    var second = date.getSeconds() + "";
    second = second.length > 1 ? second : "0" + second;
    return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + second;
}
function dateStringtoTime(time){
    if(time==null){
        return "0";
    }
    let da = new Date();
    da.setMilliseconds(0);
    da.setUTCSeconds(0);
    da.setMinutes(time.slice(14,16));
    da.setHours(time.slice(11,13));
    da.setUTCDate(time.slice(8,10));
    da.setMonth(time.slice(5,7)-1);
    da.setFullYear(time.slice(0,4));
    return da.getTime()/1000;
}
function specTypeShow(color,size){
    if(color&&size){
        return color+"-"+size;
    }else{
        return "默认"
    }
}
function checkMoney(e,data,val){
    let arr = e.split('.');
    let key = 0;
    if(arr.length>=2){
        if(arr[1].length>2){
            arr[1]=arr[1].slice(0,2);
        }
        key = arr[0]+"."+arr[1];
    }else{
        key = parseInt(e);
    }
    if(!key||key<0){
        key = 0;
    }else if(key>1000000000){
        key = 1000000000;
    }
    data[val] = key;
}
function checkCommonMaxMoney(e,data,val,maxValue){
    if(maxValue<1){
        data[val] = 0;
    }else{
        this.checkMoney(e,data,val);
        if(data[val]>maxValue){
            data[val] = maxValue;
        }
    }
}
function checkNumber(e,data,val){
    let key = parseInt(e);
    if(!key){
        key = 0;
    }else if(key>10000000){
        key = 10000000;
    }
    data[val] = key;
}
function checkCommonMaxNumber(e,data,val,maxValue){
    if(maxValue<1){
        data[val] = 0;
    }else{
        this.checkNumber(e,data,val);
        if(data[val]>maxValue){
            data[val] = maxValue;
        }
    }
    
}
function checkMaxNumber(e,data,val){
    this.checkNumber(e,data,val);
    var n = data.count * data.unit + data.num;
    if(n>data.maxnum){
        if(global.buyType==2){
            data.count = 0;
            data.num = data.maxnum;
        }else{
            data.count = Math.floor(data.maxnum/data.unit);
            data.num = data.maxnum - data.count * data.unit;
        }
    }
}
function checkPhone(ph){
    //校验手机号，号段主要有(不包括上网卡)：130~139、150~153，155~159，180~189、170~171、    176~178。14号段为上网卡专属号段
    // let regs = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9])|(199))\d{8}$/;
    let regs = /^\d{6,}$/;
    if(ph==""){
        return false;
    }
    if(!regs.test(ph)){
        return false;
    }else{
        return true;
    }
}
function initPickerOptions(){
    let shortcuts = [{
        text:"今天",
        onClick(picker) {
            let time = dayformat(new Date());
            let end = time +' 23:59:59';
            let start = time +' 00:00:00';
            picker.$emit('pick', [start, end]);
        }
    },{
        text:"最近7天",
        onClick(picker) {
            let time = new Date();
            let end = dayformat(time)+' 23:59:59';
            time.setDate(time.getDate() - 6);
            let start = dayformat(time)+' 00:00:00';
            picker.$emit('pick', [start, end]);
        }
    },{
        text: '最近30天',
        onClick(picker) {
            let time = new Date();
            let end = dayformat(time)+' 23:59:59';
            time.setDate(time.getDate() - 29);
            let start = dayformat(time)+' 00:00:00';
            picker.$emit('pick', [start, end]);
        }
    },{
        text: '上个月',
        onClick(picker) {
            let time = new Date();
            time.setDate(0);
            let end = dayformat(time)+' 23:59:59';
            time.setDate(1);
            let start = dayformat(time)+' 00:00:00';
            picker.$emit('pick', [start, end]);
        }
    },{
        text: '最近90天',
        onClick(picker) {
            let time = new Date();
            let end = dayformat(time)+' 23:59:59';
            time.setDate(time.getDate() - 89);
            let start = dayformat(time)+' 00:00:00';
            picker.$emit('pick', [start, end]);
        }
    },{
        text: '上半年',
        onClick(picker) {
            let year = new Date().getFullYear();
            let start = year+'-01-01 00:00:00';
            let end = year+'-06-30 23:59:59';
            picker.$emit('pick', [start, end]);
        }
    },{
        text: '下半年',
        onClick(picker) {
            let year = new Date().getFullYear();
            let start = year+'-07-01 00:00:00';
            let end = year+'-12-31 23:59:59';
            picker.$emit('pick', [start, end]);
        }
    },{
        text: '今年',
        onClick(picker) {
            let year = new Date().getFullYear();
            let start = year+'-01-01 00:00:00';
            let end = year+'-12-31 23:59:59';
            picker.$emit('pick', [start, end]);
        }
    }];
    return shortcuts;
}
function changeNumDesc(obj,str1,str2,str3){
	if(!str1){str1="amount";}
	if(!str2){str2="parts";}
	if(!str3){str3="unit";}
	let str = "";
	if(global.buyType==0){
		str+=obj[str1]+global.pack;
		if(obj[str2]!=0){
			str+=obj[str2]+global.unit;
		}
	}else if(global.buyType==1){
		str+=obj[str1]+global.pack;
	}else if(global.buyType==2){
		str+=obj[str3]+global.unit;
	}
	return str;
}

function changeSendDesc(number,punit){
	if((!punit)||punit<=0){
		punit = 1;
	}
	let str = ""
	if(global.buyType==2){
		str = number+global.unit;
	}else{
		let count = 0;
		if(number>0){
			count = Math.floor(number/punit);
		}else{
			count = Math.ceil(number/punit);
		}
		str = count+global.pack;
		let num = number-count*punit;
		if(global.buyType==0&&num!=0){
			str+=num+global.unit;
		}
	}
	return str;
}
export default{
    checkLimits,
    hasLimits,
    dayformat,
    format,
    formats,
    dateStringtoTime,
    specTypeShow,
    success,
    warning,
    info,
    error,
    checkWindowsEnv,
    checkHarmonyEnv,
    checkNumber,
    checkMaxNumber,
    checkCommonMaxNumber,
    checkCommonMaxMoney,
    checkMoney,
    checkPhone,
    initPickerOptions,
    changeNumDesc,
    changeSendDesc,
} 